import {mixins} from "../app/mixin";

mixins.push({
    el: '.commitmentSelector',
    data: () => ({
        selectedCommitment: 0,
        isContentBoxOpened: false,
    }),
    computed: {
        contentList() {
            return [
                {
                    id: 0,
                    img: 'b-certified-badge-score',
                    content: 'Corporate.About.Content.Commitments.BCorp.Desktop',
                    url: 'https://bcorporation.net/directory/semtrio',
                    alt: 'B-Certified-Badge-Score',
                    mobile: {
                        head: 'Corporate.About.Content.Commitments.BCorp.Mobile.Title',
                        content: 'Corporate.About.Content.Commitments.BCorp.Mobile.Text',
                        img: 'b-certified-corp',
                        alt: 'B-Certified-Corp',
                    },
                },
                {
                    id: 1,
                    img: 'un-global-compact-darken',
                    content: 'Corporate.About.Content.Commitments.UNGlobal.Desktop',
                    alt: 'UN-Global-Compact-Darken',
                    mobile: {
                        head: 'Corporate.About.Content.Commitments.UNGlobal.Mobile.Title',
                        content: 'Corporate.About.Content.Commitments.UNGlobal.Mobile.Text',
                        img: 'un-global-compact-darken',
                        alt: 'UN-Global-Compact-Darken',
                    },
                },
                {
                    id: 2,
                    img: 'climate-business-colored',
                    content: 'Corporate.About.Content.Commitments.ClimateBusiness.Desktop',
                    alt: 'ClimateBusiness-Colored',
                    url: 'https://co2nsensus.com/badges/subscription/14bfb6ff-e584-4b59-9d57-92e74b2151b1/Semtrio%20Sustainability',
                    mobile: {
                        head: 'Corporate.About.Content.Commitments.ClimateBusiness.Mobile.Title',
                        content: 'Corporate.About.Content.Commitments.ClimateBusiness.Mobile.Text',
                        img: 'climate-business-colored',
                        alt: 'ClimateBusiness-Colored',
                    },
                },
                {
                    id: 3,
                    img: 'gri-vertical',
                    content: 'Corporate.About.Content.Commitments.GRI.Desktop',
                    alt: 'GRI-Vertical',
                    mobile: {
                        head: 'Corporate.About.Content.Commitments.GRI.Mobile.Title',
                        content: 'Corporate.About.Content.Commitments.GRI.Mobile.Text',
                        img: 'gri-large',
                        alt: 'GRI-Commitment-Mobile',
                    },
                },
                {
                    id: 4,
                    img: 'cdp',
                    alt: 'CDP',
                    content: 'Corporate.About.Content.Commitments.CDP.Desktop',
                    mobile: {
                        head: 'Corporate.About.Content.Commitments.CDP.Mobile.Title',
                        content: 'Corporate.About.Content.Commitments.CDP.Mobile.Text',
                        img: 'cdp',
                        alt: 'CDP',
                    },
                }
            ]
        },
        selectedCommitmentObject() {
            return this.contentList.find((commitment) => commitment.id === this.selectedCommitment)
        },
    },
    watch: {
        selectedCommitment() {
            this.isContentBoxOpened = false
        },
    },
    methods: {
        setSelectedCommitment(commitmentId) {
            if (this.selectedCommitment !== commitmentId) {
                this.selectedCommitment = commitmentId
            }
        },
        toggleContentBox() {
            this.isContentBoxOpened = !this.isContentBoxOpened
        },
        getImagePath(img) {
            return 'build/images/badges/' + img + '.png';
        },
    },
});